module.exports = __webpack_public_path__ + "img/c23cb93ac090cd10071cf6cd8ad0394e.png";